"use client";

import { Button } from "./ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import Link from "next/link";

export const CTASection = () => {
  return (
    <section className="py-24 px-4 sm:px-6 md:px-12 lg:px-20 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-background/50 via-background to-background/50 pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90vw] max-w-[600px] h-[90vw] max-h-[600px] bg-gradient-glow opacity-30 blur-3xl pointer-events-none" />

      <div className="max-w-4xl mx-auto text-center relative z-10">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-card border border-border mb-8">
          <Sparkles className="w-4 h-4 text-primary" />
          <span className="text-sm text-muted-foreground">Start Growing Today</span>
        </div>

        {/* Headline */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
          Ready to{" "}
          <span className="bg-gradient-primary bg-clip-text text-transparent">
            Accelerate
          </span>{" "}
          Your Growth?
        </h2>

        {/* Description */}
        <p className="text-xl md:text-2xl text-muted-foreground mb-12 leading-relaxed max-w-2xl mx-auto">
          Connect your Supabase project in minutes and start uncovering growth opportunities with AI-powered analytics.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link href="/signup">
            <Button
              size="lg"
              variant="hero"
              className="text-lg px-8 py-6 group"
            >
              Get Started Free
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          <Link href="/about">
            <Button
              size="lg"
              variant="outline"
              className="text-lg px-8 py-6"
            >
              Learn More
            </Button>
          </Link>
        </div>

        {/* Trust Badge */}
        <p className="text-sm text-muted-foreground mt-8">
          No credit card required • 5 minute setup
        </p>
      </div>
    </section>
  );
};
